// Don't modify anything except the last testing one's
const APP_CONSTANTS = {};

// For new staging
if (window.location.origin.indexOf("staging") > -1) {
  APP_CONSTANTS.apiUrl = "https://v4-staging-api.instantconsult.com.au";
  APP_CONSTANTS.pmsURL = "https://staging-pr.instantconsult.com.au";
  APP_CONSTANTS.patientURL = "https://staging-patient.instantconsult.com.au";
  APP_CONSTANTS.stripeKey = "pk_test_QZZD3xvNi8fL0FOfkbPhoafE";
} else if (window.location.origin.indexOf("pr") > -1) {
  // for live
  APP_CONSTANTS.apiUrl = "https://v4-live-api.instantconsult.com.au";
  APP_CONSTANTS.pmsURL = "https://pr.instantconsult.com.au";
  APP_CONSTANTS.patientURL = "https://patient.instantconsult.com.au";
  APP_CONSTANTS.stripeKey = "pk_live_tNEvqj89jEDNsW5SmjhFWF4w";
} else {
  // For testing
  APP_CONSTANTS.apiUrl = "http://localhost:4000";
  APP_CONSTANTS.pmsURL = "http://localhost:3002";
  APP_CONSTANTS.patientURL = "https://staging-patient.instantconsult.com.au";
  APP_CONSTANTS.stripeKey = "pk_test_QZZD3xvNi8fL0FOfkbPhoafE";
}

export default APP_CONSTANTS;
